module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Panel_16"],"path":[{"$":{"d":"M10,13V12H9V11h6V1H1V11H7v1H6v1H0v2H6v1h4V15h6V13ZM3,9V3H13V9Zm6,6H7V13H9Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Panel_16.svg
// module id = MZew
// module chunks = 1